"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import Mute from "~/components/icons/mute-eon";
import Pause from "~/components/icons/pause-eon";
import Play from "~/components/icons/play-eon";
import Volume from "~/components/icons/volume-eon";
import { env } from "~/setup/env";
const ReactPlayer = dynamic(() => import("react-player"), {
  ssr: false
});
interface JobAdVideoProps {
  aspectRatio?: "16:9" | "1:1" | "9:16" | "4:3";
  buttonColor?: string;
  className?: string;
  handleClick?: () => void;
  hideControls?: boolean;
  loop?: boolean;
  muted?: boolean;
  playOnLoad?: boolean;
  playsInline?: boolean;
  thumbnailSrc?: string;
  videoUrl?: string;
}
const ASPECT_RATIO_CLASSES = {
  "16:9": "aspect-video",
  "1:1": "aspect-square",
  "9:16": "aspect-[9/16]",
  "4:3": "aspect-[4/3]"
} as const;
export default function JobAdVideo(t0) {
  const $ = _c(57);
  const {
    videoUrl,
    thumbnailSrc,
    className,
    aspectRatio: t1,
    loop: t2,
    playOnLoad: t3,
    buttonColor,
    hideControls: t4,
    handleClick,
    playsInline: t5,
    muted: t6
  } = t0;
  const aspectRatio = t1 === undefined ? "16:9" : t1;
  const loop = t2 === undefined ? true : t2;
  const playOnLoad = t3 === undefined ? false : t3;
  const hideControls = t4 === undefined ? false : t4;
  const playsInline = t5 === undefined ? true : t5;
  const muted = t6 === undefined ? true : t6;
  const [isMuted, setIsMuted] = useState(muted);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  let t7;
  let t8;
  if ($[0] !== playOnLoad) {
    t7 = () => {
      if (!playOnLoad) {
        setIsPlaying(false);
        return;
      }
      const isDesktop = window.matchMedia("(min-width: 768px)").matches;
      setIsPlaying(isDesktop);
    };
    t8 = [playOnLoad];
    $[0] = playOnLoad;
    $[1] = t7;
    $[2] = t8;
  } else {
    t7 = $[1];
    t8 = $[2];
  }
  useEffect(t7, t8);
  if (!videoUrl) {
    return null;
  }
  const videoSrc = videoUrl.startsWith("http") ? videoUrl : `${env.NEXT_PUBLIC_ASSET_URL}images/videos/${videoUrl}`;
  let t9;
  if ($[3] !== thumbnailSrc || $[4] !== videoUrl) {
    t9 = thumbnailSrc ? `${env.NEXT_PUBLIC_ASSET_URL}${thumbnailSrc}` : `${env.NEXT_PUBLIC_ASSET_URL}images/videos/${videoUrl.replace(".mp4", ".webp")}`;
    $[3] = thumbnailSrc;
    $[4] = videoUrl;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  const thumbnailUrl = t9;
  const aspectClass = ASPECT_RATIO_CLASSES[aspectRatio];
  let t10;
  if ($[6] !== aspectClass || $[7] !== className) {
    t10 = cn("relative w-full print:hidden", aspectClass, className);
    $[6] = aspectClass;
    $[7] = className;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  const t11 = `url(${thumbnailUrl})`;
  let t12;
  if ($[9] !== t11) {
    t12 = {
      backgroundImage: t11,
      backgroundSize: "contain"
    };
    $[9] = t11;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] !== isMuted || $[12] !== isPlaying || $[13] !== loop || $[14] !== playsInline || $[15] !== videoSrc) {
    t13 = isPlaying && <ReactPlayer controls={false} height="100%" loop={loop} muted={isMuted} onReady={() => setIsLoading(false)} playing={isPlaying} playsInline={playsInline} preload="auto" src={videoSrc} volume={0.2} width="100%" />;
    $[11] = isMuted;
    $[12] = isPlaying;
    $[13] = loop;
    $[14] = playsInline;
    $[15] = videoSrc;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t12 || $[18] !== t13) {
    t14 = <div className="h-full w-full" style={t12}>{t13}</div>;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const t15 = isPlaying ? "Pause" : "Play";
  const t16 = buttonColor || "bg-primary";
  const t17 = (!isPlaying && isLoading || hideControls) && "hidden";
  let t18;
  if ($[20] !== t16 || $[21] !== t17) {
    t18 = cn(t16, "z-10 flex h-8 w-8 cursor-pointer select-none items-center justify-center rounded p-2 opacity-50 transition-opacity hover:opacity-80 active:opacity-90 md:h-12 md:w-12", t17);
    $[20] = t16;
    $[21] = t17;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== handleClick || $[24] !== isPlaying) {
    t19 = () => {
      setIsPlaying(!isPlaying);
      if (handleClick) {
        handleClick();
      }
    };
    $[23] = handleClick;
    $[24] = isPlaying;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] !== isPlaying) {
    t20 = isPlaying ? <Pause className="size-6 text-white" /> : <Play className="size-6 text-white" />;
    $[26] = isPlaying;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  if ($[28] !== t15 || $[29] !== t18 || $[30] !== t19 || $[31] !== t20) {
    t21 = <button aria-label={t15} className={t18} onClick={t19} type="button">{t20}</button>;
    $[28] = t15;
    $[29] = t18;
    $[30] = t19;
    $[31] = t20;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  const t22 = isMuted ? "Unmute" : "Mute";
  const t23 = buttonColor || "bg-primary";
  const t24 = hideControls && "hidden";
  let t25;
  if ($[33] !== t23 || $[34] !== t24) {
    t25 = cn(t23, "z-10 ml-2 flex h-8 w-8 cursor-pointer select-none items-center justify-center rounded p-2 opacity-50 transition-opacity hover:opacity-80 active:opacity-90 md:h-12 md:w-12", t24);
    $[33] = t23;
    $[34] = t24;
    $[35] = t25;
  } else {
    t25 = $[35];
  }
  let t26;
  if ($[36] !== isMuted) {
    t26 = () => setIsMuted(!isMuted);
    $[36] = isMuted;
    $[37] = t26;
  } else {
    t26 = $[37];
  }
  let t27;
  if ($[38] !== isMuted) {
    t27 = isMuted ? <Mute className="size-6 text-white" /> : <Volume className="size-6 text-white" />;
    $[38] = isMuted;
    $[39] = t27;
  } else {
    t27 = $[39];
  }
  let t28;
  if ($[40] !== t22 || $[41] !== t25 || $[42] !== t26 || $[43] !== t27) {
    t28 = <button aria-label={t22} className={t25} onClick={t26} type="button">{t27}</button>;
    $[40] = t22;
    $[41] = t25;
    $[42] = t26;
    $[43] = t27;
    $[44] = t28;
  } else {
    t28 = $[44];
  }
  let t29;
  if ($[45] !== t21 || $[46] !== t28) {
    t29 = <div className="absolute top-0 right-2 flex justify-center"><div className="mt-2 flex h-min w-full max-w-screen-xl justify-end">{t21}{t28}</div></div>;
    $[45] = t21;
    $[46] = t28;
    $[47] = t29;
  } else {
    t29 = $[47];
  }
  let t30;
  if ($[48] !== buttonColor || $[49] !== handleClick || $[50] !== isPlaying) {
    t30 = !isPlaying && <button aria-label="Play video" className={cn(buttonColor || "bg-primary", "absolute top-1/2 left-1/2 flex h-20 w-20 -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded-lg opacity-60 transition-opacity hover:opacity-80 active:opacity-90")} onClick={() => {
      setIsPlaying(true);
      setIsLoading(false);
      if (handleClick) {
        handleClick();
      }
    }} type="button"><Play className="size-12 text-white" /></button>;
    $[48] = buttonColor;
    $[49] = handleClick;
    $[50] = isPlaying;
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  let t31;
  if ($[52] !== t10 || $[53] !== t14 || $[54] !== t29 || $[55] !== t30) {
    t31 = <div className={t10} id="video">{t14}{t29}{t30}</div>;
    $[52] = t10;
    $[53] = t14;
    $[54] = t29;
    $[55] = t30;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  return t31;
}